import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface CategoryTabsProps {
  categories: { slug: string; label: string; icon: string }[];
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onCategoryChange(cat.slug)}
          className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
            activeCategory === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-white border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
            <i className={cat.icon}></i>
          </span>
          {cat.label}
        </button>
      ))}
    </div>
  );
}